module.exports = "/_next/static/images/icon_angle-down-982c5d59058a753878d359d7546410ee.svg";